// extracted by mini-css-extract-plugin
export default {"container":"BillingPage_container__lXxyL","tabsContainer":"BillingPage_tabsContainer__2zNCA","tab":"BillingPage_tab__BGFXg","isSelected":"BillingPage_isSelected__awhaY"};